import { render, staticRenderFns } from "./ItemAnd.vue?vue&type=template&id=2535b20a&scoped=true&"
import script from "./ItemAnd.vue?vue&type=script&lang=js&"
export * from "./ItemAnd.vue?vue&type=script&lang=js&"
import style0 from "./ItemAnd.vue?vue&type=style&index=0&id=2535b20a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2535b20a",
  null
  
)

export default component.exports